const CustomToolTip = ({ prop, data }) => {
  const { label } = prop;

  return (
    <div className="bg-surface-elevated border border-edge shadow-overlay rounded-xl px-4 py-3">
      <h2 className="text-[12px] font-medium mb-2 text-light-gray">
        <span>{data[label]?.name}</span>
      </h2>
      <hr className="border-edge-faint" />
      <h2 className="text-[13px] font-medium mt-2 text-text-secondary">
        Total Collections :{" "}
        <span className="text-heading-color font-semibold tabular-nums">
          £{Number(data[label]?.totalCollection)?.toFixed(2)}
        </span>
      </h2>
    </div>
  );
};

export default CustomToolTip;
